import { Component, OnInit, ElementRef, ViewChild, OnDestroy } from '@angular/core';
import { DashboardService } from '../dashboard.service';
import { Router } from '@angular/router';
import * as Highcharts from 'highcharts';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { environment } from 'src/environments/environment';
import { HighchartsService } from '../highchart.service';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil, find } from 'rxjs/operators';
import { MatOption } from '@angular/material';
import * as jspdf from 'jspdf';
import 'jspdf-autotable';
import { alarmError } from 'src/app/classes/device';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit, OnDestroy {
  @ViewChild('allSelected', { static: false }) private allSelected: MatOption;
  @ViewChild('allSelected1', { static: false }) private allSelected1: MatOption;
  @ViewChild('charts', { static: false }) chartEl: ElementRef;

  private ResponseVerifiedGetParamList: Subject<any> = new Subject();
  private ResponseVerifiedGetInverterList: Subject<any> = new Subject();
  private ResponseVerifiedReportGraph: Subject<any> = new Subject();

  pipe = new DatePipe('en-US')
  public graphForm: FormGroup;
  public graphFormGrid: FormGroup;
  public reportDownloadForm: FormGroup;
  inverterObj: any;
  dataObject: any;
  public inverterDetails_id: any;
  public subDevice_id: any;
  public serial_no: any;
  subDeviceId: any;
  serialNo: any;
  show: any = ''
  deviceInfoList: any = {};
  deviceInfoListToCsv: any = {};
  monthlyDeviceInfoList: any = [];
  yearlyDeviceInfoList: any = [];
  deviceInfoTotalYearly: any = [];
  deviceInfoTotalMonthly: any = [];
  // content: any = [];
  deviceInfoTotal: any = [];
  status: any[];
  formula = 'Formula 1';
  fileUrl;
  time: any;
  visible = true;
  minDate = new Date(2017, 1, 1);
  maxDate = new Date();
  public myFormattedDate: any;
  public myFormattedYear: any;
  public myFormattedMonth: any;
  public FormattedYear: any;
  public loginName = localStorage.login_id;
  public authToken = localStorage.loginToken;
  logo = localStorage.logo;
  public pdfMake: any;
  dayDate: any;
  monthYear: any;
  year: any;
  csvFlag = false;
  yearGraphFlag = false;
  csvMonthFlag = false;
  public highcharts = Highcharts;
  paramKeyArray: any = [];
  public role: any;
  public roleName: string;
  public inverterList: any[];
  public parameterList: any = [];
  month_data: any = [];
  month_categories: any;
  updateFlag: boolean;
  graphDetailsArray: any;
  custom = false;
  currentDate: any;
  device_Info: any = [];
  graphRequestObject: any = {};
  formattedToDate: string;
  formattedFromDate: string;
  categories_Day: any[];
  data_Day: any = [];
  baseURL: any;
  data1Series: string;
  uploadFlagSpinner: boolean;
  selecttab: any = 'solar';
  DG_user: boolean;
  // graph options
  myOptions: {
    chart: { type: string; }; tooltip: { shared: boolean, }; title: { text: string; }; xAxis: {
      categories: any[];
    }; yAxis: []; legend: { reversed: boolean; }; plotOptions: { series: { stacking: string; }; }; series: [], exporting: {};
  };
  epcId: any;
  docDefinition: any;
  alarmObj: {};
  yaxis: any = []
  tabselection: string = 'parameter_trends';
  fileType_Pdf: boolean;
  fileType_Csv: boolean;
  constructor(private dashbord: DashboardService, private router: Router, private fb: FormBuilder,
    private highchart: HighchartsService, private toastr: ToastrService) {

    this.epcId = localStorage.id;
    this.baseURL = environment.apiBase;
    this.role = localStorage.role;
    if (this.role === '1') {
      this.roleName = 'admin';
    } else if (this.role === '2') {
      this.roleName = 'epc';
    } else if (this.role === '3') {
      this.roleName = 'wms';
    } else if (this.role === '4') {
      this.roleName = 'normal';
    } else if (this.role === '6') {
      this.roleName = 'ze';
    } else if (this.role === '7') {
      this.roleName = 'dg';
    }
  }

  ngOnInit() {
    Highcharts.setOptions({
      lang: {
        decimalPoint: '.',
        thousandsSep: ''
      }
    });

    // this.selecttab='solar',


    //   this.tabselection = 'parameter_trends',
    this.graphForm = this.fb.group({
      inverter_id: ['', Validators.required],
      parameter_id: ['', Validators.required],
      ToDate: ['', Validators.required],
      FromDate: ['', Validators.required],
      timewindow: [null, Validators.required]

    });
    if (this.roleName == 'normal') {
      this.getInverterList();
    }
    if (this.roleName == 'ze' || this.roleName == 'dg') {
      // this.getInverterListZE();
      this.showParameterTrendsTab(this.tabselection)
    }
    // this.showSolarTrendsTab(this.selecttab),

    this.reportDownloadForm = this.fb.group({
      dayDate: ['', Validators.required],
      monthYear: ['', Validators.required],
      year: ['', Validators.required],
      inverter_csv: ['', Validators.required],
      inverter_date: ['', Validators.required]
    });
  }

  get f() { return this.reportDownloadForm.controls; }
  get f1() { return this.graphForm.controls; }

  // select all DropDown in Inverter List
  selectAllInverter(value) {
    if (this.allSelected1.selected) {
      this.graphForm.controls.inverter_id
        .patchValue([...this.inverterList.map(item => item), 0]);
      this.graphForm.value.inverter_id.pop();
    } else
      this.graphForm.controls.inverter_id.patchValue([]);
    this.getParameterList();
  }
  // select all DropDown in Inverter List
  selectAllInverterZE(value) {
    if (this.allSelected1.selected) {
      this.graphForm.controls.inverter_id
        .patchValue([...this.inverterList.map(item => item), 0]);
      this.graphForm.value.inverter_id.pop();
    } else
      this.graphForm.controls.inverter_id.patchValue([]);
    this.getParameterListZE();
  }

  selectAllInverterZEGrid(value) {
    if (this.allSelected1.selected) {
      this.graphFormGrid.controls.inverter_id
        .patchValue([...this.inverterList.map(item => item), 0]);
      this.graphFormGrid.value.inverter_id.pop();
    } else
      this.graphFormGrid.controls.inverter_id.patchValue([]);
    this.getParameterListZEGrid();
  }


  // select all DropDown in parameter List
  toggleAllSelection() {
    if (this.allSelected.selected) {
      this.graphForm.controls.parameter_id
        .patchValue([...this.parameterList.map(item => item), 0]);
      var last = this.graphForm.value.parameter_id.pop();
    } else {
      this.graphForm.controls.parameter_id.patchValue([]);
    }
  }

  toggleAllSelectionGrid() {
    if (this.allSelected.selected) {
      this.graphFormGrid.controls.parameter_id
        .patchValue([...this.parameterList.map(item => item), 0]);
      var last = this.graphFormGrid.value.parameter_id.pop();
    } else {
      this.graphFormGrid.controls.parameter_id.patchValue([]);
    }
  }


  tosslePerOne(all) {
    if (this.allSelected.selected) {
      this.allSelected.deselect();
      return false;
    }
  }

  onSelectOneInverter(all) {
    if (this.allSelected1.selected) {
      this.allSelected1.deselect();
      return false;
    }
    this.getParameterList();

  }
  onSelectOneInverterZE(all) {
    if (this.allSelected1.selected) {
      this.allSelected1.deselect();
      return false;
    }
    if (this.selecttab == 'solar') {
      this.getParameterListZE();
    } else if (this.selecttab == 'grid') {
      this.getParameterListZEGrid();
    }



  }


  showParameterTrendsTab(tab) {
    this.tabselection = tab;
    this.show = '';
    if (this.roleName == 'ze' || this.roleName == 'dg') {
      this.showSolarTrendsTab('solar');
    }

  }

  showSolarTrendsTab(tab) {
    this.selecttab = tab;
    this.csvFlag = false;
    this.csvMonthFlag = false;
    this.yearGraphFlag = false;

    if (this.tabselection == 'parameter_trends' && this.selecttab == 'solar') {
      this.inverterList = [];
      this.parameterList = [];
      this.getInverterListZE();
      this.graphForm.reset();
    }


  }


  showGridReportab(tab) {
    this.reportDownloadForm.reset();
    this.selecttab = tab;
    this.tabselection = 'download_report';
    this.csvFlag = false;
    this.csvMonthFlag = false;
    this.yearGraphFlag = false;
    // this.inverterList = [];
    // this.parameterList = [];
    // this.getInverterListZE();
    // this.graphForm.reset();
  }
  showLoadReportab(tab) {
    this.reportDownloadForm.reset();
    this.selecttab = tab;
    this.tabselection = 'download_report';
    this.csvFlag = false;
    this.csvMonthFlag = false;
    this.yearGraphFlag = false;
    // this.inverterList = [];
    // this.parameterList = [];
    // this.getInverterListZE();
    // this.graphForm.reset();
  }
  showDgReportab(tab) {
    this.reportDownloadForm.reset();
    this.selecttab = tab;
    this.tabselection = 'download_report';
    this.csvFlag = false;
    this.csvMonthFlag = false;
    this.yearGraphFlag = false;
    // this.inverterList = [];
    // this.parameterList = [];
    // this.getInverterListZE();
    // this.graphForm.reset();
  }
  showPlantReportab(tab) {
    this.reportDownloadForm.reset();
    this.selecttab = tab;
    this.tabselection = 'download_report';
    this.csvFlag = false;
    this.csvMonthFlag = false;
    this.yearGraphFlag = false;
    // this.inverterList = [];
    // this.parameterList = [];
    // this.getInverterListZE();
    // this.graphForm.reset();
  }
  showDownloadReportab(tab) {
    this.reportDownloadForm.reset();
    this.tabselection = tab;
    this.show = 'yes';
  }


  // select dropdown date, month, date
  onChangeDate(value) {
    if (value === 'day') {
      this.csvFlag = true;
      this.csvMonthFlag = false;
      this.yearGraphFlag = false;
    } else if (value === 'month') {
      this.csvFlag = false;
      this.csvMonthFlag = true;
      this.yearGraphFlag = false;
    } else if (value === 'year') {
      this.csvFlag = false;
      this.csvMonthFlag = false;
      this.yearGraphFlag = true;
    }
  }

  // Select DropDown Of Time Window for Normal User
  onChangeTimeWindow(value) {
    if (value === 'Today') {
      this.custom = false;
      this.graphForm.get('ToDate').setValue(new Date());
      this.graphForm.get('FromDate').setValue(new Date());
    } else if (value === 'Last 7 Days') {
      this.custom = false;
      const x = new Date(new Date().getTime() - (6 * 24 * 60 * 60 * 1000));
      this.graphForm.get('ToDate').setValue(new Date);
      this.graphForm.get('FromDate').setValue(x);
      console.log(this.graphForm.value.FromDate);
      console.log(this.graphForm.value.ToDate);
    } else if (value === 'Last 30 Day') {
      this.custom = false;
      const x = new Date(new Date().getTime() - (29 * 24 * 60 * 60 * 1000));
      this.graphForm.get('ToDate').setValue(new Date);
      this.graphForm.get('FromDate').setValue(x);
    } else if (value === 'Custom') {
      this.custom = true;
    }

  }


  // get inverter list on drop Down for Normal User
  public getInverterList() {

    this.dashbord.getInverterList()
      .pipe(takeUntil(this.ResponseVerifiedGetInverterList))
      .subscribe(
        async result => {
          if (result.status) {
            this.inverterList = result.resultObject;

          } else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(result.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  // get inverter list on drop Down for Normal User
  public getInverterListZE() {
    this.dashbord.getInverterListZE()
      .pipe(takeUntil(this.ResponseVerifiedGetInverterList))
      .subscribe(
        async result => {
          if (result.status) {
            this.inverterList = result.resultObject;

          } else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(result.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // get Parameter list on drop Down for Normal User
  public getParameterList() {
    this.inverterObj = {
      device_info: this.graphForm.controls.inverter_id.value
    };
    this.dashbord.getParamNoAndParamNameList(this.inverterObj)
      .pipe(takeUntil(this.ResponseVerifiedGetParamList))
      .subscribe(
        async result => {
          this.parameterList = [];
          if (result.status) {
            this.parameterList = result.resultObject;

          } else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(result.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // get Parameter list on drop Down for Normal User
  public getParameterListZE() {
    this.inverterObj = {
      device_info: this.graphForm.controls.inverter_id.value
    };
    this.dashbord.getParamNoAndParamNameListZE(this.inverterObj)
      .pipe(takeUntil(this.ResponseVerifiedGetParamList))
      .subscribe(
        async result => {
          this.parameterList = [];
          if (result.status) {
            this.parameterList = result.resultObject;

          } else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(result.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }


  public getParameterListZEGrid() {
    this.inverterObj = {
      device_info: this.graphFormGrid.controls.inverter_id.value
    };
    this.dashbord.getParamNoAndParamNameListZE(this.inverterObj)
      .pipe(takeUntil(this.ResponseVerifiedGetParamList))
      .subscribe(
        async result => {
          this.parameterList = [];
          if (result.status) {
            this.parameterList = result.resultObject;

          } else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(result.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }


  // csv download today code normal
  public csvDownloadToday(loginName) {
    const pipe = new DatePipe('en-US');
    this.myFormattedDate = pipe.transform(this.reportDownloadForm.value.dayDate, 'yyyy-MM-dd');
    window.location.href = this.baseURL + '/normal/Report/csvToday?date=' + this.myFormattedDate + '&user_id=' + loginName + '&Authorization=' + this.authToken;

  }
  // csv download monthly code normal
  public csvDownloadMonthly(loginName) {
    const pipe = new DatePipe('en-US');
    this.myFormattedMonth = pipe.transform(this.reportDownloadForm.value.monthYear, 'MM');
    this.FormattedYear = pipe.transform(this.reportDownloadForm.value.monthYear, 'yyyy');
    window.location.href = this.baseURL + '/normal/Report/csvMonth?month=' + this.myFormattedMonth + '&year=' + this.FormattedYear + '&user_id=' + loginName + '&Authorization=' + this.authToken;

  }
  // csv download year normal
  public csvDownloadYear(loginName) {

    const pipe = new DatePipe('en-US');
    this.myFormattedYear = pipe.transform(this.reportDownloadForm.value.year, 'yyyy');
    window.location.href = this.baseURL + '/normal/Report/csvYear?year=' + this.myFormattedYear + '&user_id=' + loginName + '&Authorization=' + this.authToken;

  }

  public csvDownloadTodayZESolar(loginName) {

    const pipe = new DatePipe('en-US');
    this.myFormattedDate = pipe.transform(this.reportDownloadForm.value.dayDate, 'yyyy-MM-dd');
    window.location.href = this.baseURL + '/zedg/Report/csvToday?date=' + this.myFormattedDate + '&user_id=' + loginName + '&Authorization=' + this.authToken;

  }


  // csv download today code zeGrid
  public csvDownloadTodayZEGrid(loginName) {

    const pipe = new DatePipe('en-US');
    this.myFormattedDate = pipe.transform(this.reportDownloadForm.value.dayDate, 'yyyy-MM-dd');
    window.location.href = this.baseURL + '/zedg/Report/csvTodayGrid?date=' + this.myFormattedDate + '&user_id=' + loginName + '&Authorization=' + this.authToken;

  }
  // csv download today code zeLoad
  public csvDownloadTodayZELoad(loginName) {

    const pipe = new DatePipe('en-US');
    this.myFormattedDate = pipe.transform(this.reportDownloadForm.value.dayDate, 'yyyy-MM-dd');
    window.location.href = this.baseURL + '/zedg/Report/csvTodayLoad?date=' + this.myFormattedDate + '&user_id=' + loginName + '&Authorization=' + this.authToken;

  }
  // csv download today code zePlant
  public csvDownloadTodayZEPlant(loginName) {

    const pipe = new DatePipe('en-US');
    this.myFormattedDate = pipe.transform(this.reportDownloadForm.value.dayDate, 'yyyy-MM-dd');
    window.location.href = this.baseURL + '/zedg/Report/csvTodayPlant?date=' + this.myFormattedDate + '&user_id=' + loginName + '&Authorization=' + this.authToken;

  }
  // csv download today code dgGrid
  public csvDownloadTodayDGGrid(loginName) {

    const pipe = new DatePipe('en-US');
    this.myFormattedDate = pipe.transform(this.reportDownloadForm.value.dayDate, 'yyyy-MM-dd');
    window.location.href = this.baseURL + '/zedg/Report/csvTodayGrid?date=' + this.myFormattedDate + '&user_id=' + loginName + '&Authorization=' + this.authToken;

  }
  // csv download today code dgLoad
  public csvDownloadTodayDGLoad(loginName) {

    const pipe = new DatePipe('en-US');
    this.myFormattedDate = pipe.transform(this.reportDownloadForm.value.dayDate, 'yyyy-MM-dd');
    window.location.href = this.baseURL + '/zedg/Report/csvTodayLoad?date=' + this.myFormattedDate + '&user_id=' + loginName + '&Authorization=' + this.authToken;

  }
  // csv download today code dgDG
  public csvDownloadTodayDG_DG(loginName) {

    const pipe = new DatePipe('en-US');
    this.myFormattedDate = pipe.transform(this.reportDownloadForm.value.dayDate, 'yyyy-MM-dd');
    window.location.href = this.baseURL + '/zedg/Report/csvTodayDG?date=' + this.myFormattedDate + '&user_id=' + loginName + '&Authorization=' + this.authToken;

  }
  // csv download today code dgPlant
  public csvDownloadTodayDGPlant(loginName) {

    const pipe = new DatePipe('en-US');
    this.myFormattedDate = pipe.transform(this.reportDownloadForm.value.dayDate, 'yyyy-MM-dd');
    window.location.href = this.baseURL + '/zedg/Report/csvTodayPlant?date=' + this.myFormattedDate + '&user_id=' + loginName + '&Authorization=' + this.authToken;

  }
  public csvDownloadMonthlyZESolar(loginName) {

    const pipe = new DatePipe('en-US');
    this.myFormattedMonth = pipe.transform(this.reportDownloadForm.value.monthYear, 'MM');
    this.FormattedYear = pipe.transform(this.reportDownloadForm.value.monthYear, 'yyyy');
    window.location.href = this.baseURL + '/zedg/Report/csvMonth?month=' + this.myFormattedMonth + '&year=' + this.FormattedYear + '&user_id=' + loginName + '&Authorization=' + this.authToken;

  }

  // csv download monthly code ze
  public csvDownloadMonthlyZE(loginName) {

    const pipe = new DatePipe('en-US');
    this.myFormattedMonth = pipe.transform(this.reportDownloadForm.value.monthYear, 'MM');
    this.FormattedYear = pipe.transform(this.reportDownloadForm.value.monthYear, 'yyyy');
    window.location.href = this.baseURL + '/zedg/Report/csvGridMonth?month=' + this.myFormattedMonth + '&year=' + this.FormattedYear + '&user_id=' + loginName + '&Authorization=' + this.authToken;

  }
  // csv download monthly code zeLoad
  public csvDownloadMonthlyZELoad(loginName) {

    const pipe = new DatePipe('en-US');
    this.myFormattedMonth = pipe.transform(this.reportDownloadForm.value.monthYear, 'MM');
    this.FormattedYear = pipe.transform(this.reportDownloadForm.value.monthYear, 'yyyy');
    window.location.href = this.baseURL + '/zedg/Report/csvLoadMonth?month=' + this.myFormattedMonth + '&year=' + this.FormattedYear + '&user_id=' + loginName + '&Authorization=' + this.authToken;

  }
  // csv download monthly code zePlant
  public csvDownloadMonthlyZEPlant(loginName) {

    const pipe = new DatePipe('en-US');
    this.myFormattedMonth = pipe.transform(this.reportDownloadForm.value.monthYear, 'MM');
    this.FormattedYear = pipe.transform(this.reportDownloadForm.value.monthYear, 'yyyy');
    window.location.href = this.baseURL + '/zedg/Report/csvMonthPlant?month=' + this.myFormattedMonth + '&year=' + this.FormattedYear + '&user_id=' + loginName + '&Authorization=' + this.authToken;

  }
  // csv download monthly code dgGrid
  public csvDownloadMonthlyDGGrid(loginName) {

    const pipe = new DatePipe('en-US');
    this.myFormattedMonth = pipe.transform(this.reportDownloadForm.value.monthYear, 'MM');
    this.FormattedYear = pipe.transform(this.reportDownloadForm.value.monthYear, 'yyyy');
    window.location.href = this.baseURL + '/zedg/Report/csvGridMonth?month=' + this.myFormattedMonth + '&year=' + this.FormattedYear + '&user_id=' + loginName + '&Authorization=' + this.authToken;

  }
  // csv download monthly code dgLoad
  public csvDownloadMonthlyDGLoad(loginName) {

    const pipe = new DatePipe('en-US');
    this.myFormattedMonth = pipe.transform(this.reportDownloadForm.value.monthYear, 'MM');
    this.FormattedYear = pipe.transform(this.reportDownloadForm.value.monthYear, 'yyyy');
    window.location.href = this.baseURL + '/zedg/Report/csvLoadMonth?month=' + this.myFormattedMonth + '&year=' + this.FormattedYear + '&user_id=' + loginName + '&Authorization=' + this.authToken;

  }
  // csv download monthly code dg_DG
  public csvDownloadMonthlyDG(loginName) {

    const pipe = new DatePipe('en-US');
    this.myFormattedMonth = pipe.transform(this.reportDownloadForm.value.monthYear, 'MM');
    this.FormattedYear = pipe.transform(this.reportDownloadForm.value.monthYear, 'yyyy');
    window.location.href = this.baseURL + '/zedg/Report/csvDGMonth?month=' + this.myFormattedMonth + '&year=' + this.FormattedYear + '&user_id=' + loginName + '&Authorization=' + this.authToken;

  }
  // csv download monthly zeplant
  public csvDownloadMonthlyDGPlant(loginName) {

    const pipe = new DatePipe('en-US');
    this.myFormattedMonth = pipe.transform(this.reportDownloadForm.value.monthYear, 'MM');
    this.FormattedYear = pipe.transform(this.reportDownloadForm.value.monthYear, 'yyyy');
    window.location.href = this.baseURL + '/zedg/Report/csvMonthPlant?month=' + this.myFormattedMonth + '&year=' + this.FormattedYear + '&user_id=' + loginName + '&Authorization=' + this.authToken;

  }
  public csvDownloadYearZESolar(loginName) {

    const pipe = new DatePipe('en-US');
    this.myFormattedYear = pipe.transform(this.reportDownloadForm.value.year, 'yyyy');
    window.location.href = this.baseURL + '/zedg/Report/csvYear?year=' + this.myFormattedYear + '&user_id=' + loginName + '&Authorization=' + this.authToken;

  }

  // csv download year zeGrid
  public csvDownloadYearZE(loginName) {

    const pipe = new DatePipe('en-US');
    this.myFormattedYear = pipe.transform(this.reportDownloadForm.value.year, 'yyyy');
    window.location.href = this.baseURL + '/zedg/Report/csvGridYear?year=' + this.myFormattedYear + '&user_id=' + loginName + '&Authorization=' + this.authToken;

  }
  // csv download year zeLoad
  public csvDownloadYearZELoad(loginName) {

    const pipe = new DatePipe('en-US');
    this.myFormattedYear = pipe.transform(this.reportDownloadForm.value.year, 'yyyy');
    window.location.href = this.baseURL + '/zedg/Report/csvLoadYear?year=' + this.myFormattedYear + '&user_id=' + loginName + '&Authorization=' + this.authToken;

  }
  // csv download year zePlant
  public csvDownloadYearZEPlant(loginName) {

    const pipe = new DatePipe('en-US');
    this.myFormattedYear = pipe.transform(this.reportDownloadForm.value.year, 'yyyy');
    window.location.href = this.baseURL + '/zedg/Report/csvPlantYear?year=' + this.myFormattedYear + '&user_id=' + loginName + '&Authorization=' + this.authToken;

  }
  // csv download year dgGrid
  public csvDownloadYearDGGrid(loginName) {

    const pipe = new DatePipe('en-US');
    this.myFormattedYear = pipe.transform(this.reportDownloadForm.value.year, 'yyyy');
    window.location.href = this.baseURL + '/zedg/Report/csvGridYear?year=' + this.myFormattedYear + '&user_id=' + loginName + '&Authorization=' + this.authToken;

  }
  // csv download year dgLoad
  public csvDownloadYearDGLoad(loginName) {

    const pipe = new DatePipe('en-US');
    this.myFormattedYear = pipe.transform(this.reportDownloadForm.value.year, 'yyyy');
    window.location.href = this.baseURL + '/zedg/Report/csvLoadYear?year=' + this.myFormattedYear + '&user_id=' + loginName + '&Authorization=' + this.authToken;

  }
  // csv download year dg_Dg
  public csvDownloadYearDG_DG(loginName) {

    const pipe = new DatePipe('en-US');
    this.myFormattedYear = pipe.transform(this.reportDownloadForm.value.year, 'yyyy');
    window.location.href = this.baseURL + '/zedg/Report/csvDGYear?year=' + this.myFormattedYear + '&user_id=' + loginName + '&Authorization=' + this.authToken;

  }
  // csv download year dgPlant
  public csvDownloadYearDGPlant(loginName) {

    const pipe = new DatePipe('en-US');
    this.myFormattedYear = pipe.transform(this.reportDownloadForm.value.year, 'yyyy');
    window.location.href = this.baseURL + '/zedg/Report/csvPlantYear?year=' + this.myFormattedYear + '&user_id=' + loginName + '&Authorization=' + this.authToken;

  }




  showGraph() {
    this.graphRequestObject = {
      from: this.pipe.transform(this.graphForm.value.FromDate, 'yyyy-MM-dd'),
      to: this.pipe.transform(this.graphForm.value.ToDate, 'yyyy-MM-dd'),
      dev: this.graphForm.controls.inverter_id.value,
      param: this.graphForm.value.parameter_id
    };
    this.dashbord.getReportGraph(this.graphRequestObject)
      .pipe(takeUntil(this.ResponseVerifiedReportGraph))
      .subscribe(
        async data => {
          this.categories_Day = [];
          this.data_Day = [];
          this.graphDetailsArray = [];
          this.yaxis = [];
          if (data.status) {
            this.graphDetailsArray = data.resultObject.device;
            this.categories_Day = data.resultObject.timeStamp
            for (let p = 0; p < this.graphDetailsArray.length; p++) {
              if (p % 2 == 0) {
                var opposite = true
              } else {
                opposite = false
              }
              if (opposite) {
                this.yaxis.push({ // Primary yAxis
                  lineWidth: 1,
                  margin: -15,
                  labels: {
                    x: 5,
                    y: 5,
                    rotation: -90,
                    style: {
                      fontSize: '8px',
                      color: Highcharts.getOptions().colors[p]
                    }
                  },
                  title: {
                    text: this.graphDetailsArray[p].inv_name + " " + this.graphDetailsArray[p].param_name,
                    x: -15,
                    style: {
                      color: Highcharts.getOptions().colors[p]
                    }
                  },

                  opposite: opposite,
                });

              } else {
                this.yaxis.push({ // Primary yAxis
                  lineWidth: 1,
                  margin: -15,
                  labels: {
                    x: -5,
                    y: -5,
                    rotation: -90,
                    style: {
                      fontSize: '8px',
                      color: Highcharts.getOptions().colors[p]
                    }
                  },
                  title: {
                    text: this.graphDetailsArray[p].inv_name + " " + this.graphDetailsArray[p].param_name,
                    x: 15,
                    style: {
                      color: Highcharts.getOptions().colors[p]
                    }
                  },
                });

              }

              // set the graph serise
              this.data_Day.push({
                name: this.graphDetailsArray[p].inv_name + " " + this.graphDetailsArray[p].param_name,
                yAxis: p,
                data: this.graphDetailsArray[p].data
              });

              this.updateFlag = true;
            }
            this.myOptions = {
              chart: {
                type: 'spline'
              }, tooltip:
              {
                shared: true,

              },
              title: {
                text: ''
              },
              xAxis: {
                categories: this.categories_Day,
              },
              yAxis: this.yaxis,
              legend: {
                reversed: true
              },
              plotOptions: {
                series: {
                  stacking: 'normal'
                }
              },
              series: this.data_Day,
              exporting: {
                buttons: {
                  contextButton: {
                    menuItems: Highcharts.defaultOptions.exporting.buttons.contextButton.menuItems.slice(0, 10)
                  }
                }
              }
            };
            this.highchart.createChart(this.chartEl.nativeElement, this.myOptions);

          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
              this.data_Day = [];
              this.categories_Day = [];
              this.myOptions = {
                chart: {
                  type: 'spline'
                }, tooltip:
                {
                  shared: true,
                },
                title: {
                  text: ''
                },
                xAxis: {
                  categories: this.categories_Day
                },
                yAxis: this.yaxis,
                legend: {
                  reversed: true
                },
                plotOptions: {
                  series: {
                    stacking: 'normal'
                  }
                },
                series: this.data_Day,
                exporting: {
                  buttons: {
                    contextButton: {
                      menuItems: Highcharts.defaultOptions.exporting.buttons.contextButton.menuItems.slice(0, 10)
                    }
                  }
                }
              };
              this.highchart.createChart(this.chartEl.nativeElement, this.myOptions);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  showGraphZE() {
    this.graphRequestObject = {
      from: this.pipe.transform(this.graphForm.value.FromDate, 'yyyy-MM-dd'),
      to: this.pipe.transform(this.graphForm.value.ToDate, 'yyyy-MM-dd'),
      dev: this.graphForm.controls.inverter_id.value,
      param: this.graphForm.value.parameter_id
    };
    this.dashbord.getReportGraphZE(this.graphRequestObject)
      .pipe(takeUntil(this.ResponseVerifiedReportGraph))
      .subscribe(
        async data => {
          this.categories_Day = [];
          this.data_Day = [];
          this.graphDetailsArray = [];
          this.yaxis = [];
          if (data.status) {
            this.graphDetailsArray = data.resultObject.device;
            this.categories_Day = data.resultObject.timeStamp



            for (let p = 0; p < this.graphDetailsArray.length; p++) {
              if (p % 2 == 0) {
                var opposite = true
              } else {
                opposite = false
              }
              if (opposite) {
                this.yaxis.push({ // Primary yAxis
                  lineWidth: 1,
                  margin: -15,
                  labels: {
                    x: 5,
                    y: 5,
                    rotation: -90,
                    style: {
                      fontSize: '8px',
                      color: Highcharts.getOptions().colors[p]
                    }
                  },
                  title: {
                    text: this.graphDetailsArray[p].inv_name + " " + this.graphDetailsArray[p].param_name,
                    x: -15,
                    style: {
                      color: Highcharts.getOptions().colors[p]
                    }
                  },

                  opposite: opposite,
                });

              } else {
                this.yaxis.push({ // Primary yAxis
                  lineWidth: 1,
                  margin: -15,
                  labels: {
                    x: -5,
                    y: -5,
                    rotation: -90,
                    style: {
                      fontSize: '8px',
                      color: Highcharts.getOptions().colors[p]
                    }
                  },
                  title: {
                    text: this.graphDetailsArray[p].inv_name + " " + this.graphDetailsArray[p].param_name,
                    x: 15,
                    style: {
                      color: Highcharts.getOptions().colors[p]
                    }
                  },
                });

              }

              // set the graph serise
              this.data_Day.push({
                name: this.graphDetailsArray[p].inv_name + " " + this.graphDetailsArray[p].param_name,
                yAxis: p,
                data: this.graphDetailsArray[p].data
              });

              this.updateFlag = true;
            }
            this.myOptions = {
              chart: {
                type: 'spline'
              }, tooltip:
              {
                shared: true,

              },
              title: {
                text: ''
              },
              xAxis: {
                categories: this.categories_Day,
              },
              yAxis: this.yaxis,
              legend: {
                reversed: true
              },
              plotOptions: {
                series: {
                  stacking: 'normal'
                }
              },
              series: this.data_Day,
              exporting: {
                buttons: {
                  contextButton: {
                    menuItems: Highcharts.defaultOptions.exporting.buttons.contextButton.menuItems.slice(0, 10)
                  }
                }
              }
            };
            this.highchart.createChart(this.chartEl.nativeElement, this.myOptions);


          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
              this.data_Day = [];
              this.categories_Day = [];
              this.myOptions = {
                chart: {
                  type: 'spline'
                }, tooltip:
                {
                  shared: true,
                },
                title: {
                  text: ''
                },
                xAxis: {
                  categories: this.categories_Day
                },
                yAxis: this.yaxis,
                legend: {
                  reversed: true
                },
                plotOptions: {
                  series: {
                    stacking: 'normal'
                  }
                },
                series: this.data_Day,
                exporting: {
                  buttons: {
                    contextButton: {
                      menuItems: Highcharts.defaultOptions.exporting.buttons.contextButton.menuItems.slice(0, 10)
                    }
                  }
                }
              };
              this.highchart.createChart(this.chartEl.nativeElement, this.myOptions);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  onChangeCsv(value) {
    if (value == '1') {
      this.fileType_Pdf = false;
      this.fileType_Csv = true;
    } else if (value == '2') {
      this.fileType_Csv = false;
      this.fileType_Pdf = true;
    }
  }
  // NORMAL
  download_DayPdf() {
    var UserIdObj = {
      date: this.pipe.transform(this.reportDownloadForm.value.dayDate, 'yyyy-MM-dd'),
      user_id: this.loginName
    }
    this.dashbord.downloadNormalTodaysPdf(UserIdObj)
      .subscribe(
        async data => {
          if (data.status) {
            var responseData = data.resultObject;

            var b64image = JSON.stringify(responseData.epc_b64image);
            // remove quated string
            var base64Img = b64image.replace(/"/g, '');
            var doc = new jspdf('l', 'pt', 'a4'); //landscape page


            doc.autoTableSetDefaults({
              didDrawPage: function (data) {
                doc.addImage(base64Img, 'png', data.settings.margin.left, 10, 40, 25);
                doc.text(responseData.company_name, data.settings.margin.left + 43, 22);
                doc.text("Solar generation Daily Report", data.settings.margin.left + 550, 22);
                doc.setDrawColor(31, 78, 121);
                doc.line(0, 45, 900, 45);
              },
              margin: {
                top: 60,
                bottom: 50
              },
            })

            if (responseData.customer) {
              var demo = []
              demo.push(responseData.customer)
              doc.autoTable({
                body: demo,
                columns: [{ header: 'Customer Name', dataKey: 'customer_name' },
                {
                  header: 'Plant Capacity (KW)',
                  dataKey: 'plant_capacity'
                },
                { header: 'Address', dataKey: 'address' },
                { header: 'Date', dataKey: 'date' }]

              })
            }
            if (responseData.energy_generation) {
              var demo1 = []
              demo1.push(responseData.energy_generation)
              doc.autoTable({
                body: demo1,
                columns: [{ header: 'Daily Energy Generation (KWh)', dataKey: 'daily_energy_generation' },
                { header: 'Total Energy Generation (KWh/MWh)', dataKey: 'total_energy_generation' },
                { header: 'Specific Yeild (KWh/KWp)', dataKey: 'specific_yeild' },
                  //  { header:'Pr (%)',dataKey: 'pr' },
                ]
              })
            }
            if (responseData.generationArr) {
              doc.autoTable({
                body: responseData.generationArr,
                columns: [{ header: 'Inverter Name', dataKey: 'inverter_name' },
                { header: 'Daily Energy Generation (KWh)', dataKey: 'daily_energy_generation' },
                { header: 'Total Energy Generation (KWh/MWh)', dataKey: 'total_energy_generation' },
                { header: 'Specific Yield (KWh/KWp) ', dataKey: 'specific_yield' }]
              })
            }


            // doc.save("Daily_Report "+ this.pipe.transform(this.reportDownloadForm.value.dayDate, 'yyyy-MM-dd')+'.pdf' );

            doc.save(responseData.title + '.pdf');
            this.toastr.success(data.message);
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  download_MonthPdf() {
    var UserIdObj = {
      month: this.pipe.transform(this.reportDownloadForm.value.monthYear, 'MM'),
      year: this.pipe.transform(this.reportDownloadForm.value.monthYear, 'yyyy'),
      user_id: this.loginName
    }
    this.dashbord.downloadNormalMonthPdf(UserIdObj)
      .subscribe(
        async data => {
          if (data.status) {
            var responseData = data.resultObject;
            var b64image = JSON.stringify(responseData.epc_b64image);
            // remove quated string
            var base64Img = b64image.replace(/"/g, '');
            var doc = new jspdf('l', 'pt', 'a4'); //landscape page
            doc.autoTableSetDefaults({
              didDrawPage: function (data) {
                doc.addImage(base64Img, 'png', data.settings.margin.left, 10, 40, 25);
                doc.text(responseData.company_name, data.settings.margin.left + 43, 22);
                doc.text("Solar generation Monthly Report", data.settings.margin.left + 535, 22);
                doc.setDrawColor(31, 78, 121);
                doc.line(0, 45, 900, 45);
              },
              margin: {
                top: 60,
                bottom: 50
              },
            })
            if (responseData.customer) {
              var demo = []
              demo.push(responseData.customer)
              doc.autoTable({
                body: demo,
                columns: [{ header: 'Customer Name', dataKey: 'customer_name' }, { header: 'Plant Capacity (KW)', dataKey: 'plant_capacity' },
                { header: 'Address', dataKey: 'address' }, { header: 'Date', dataKey: 'month' }]
              })
            }
            if (responseData.energy_generation) {
              var demo1 = []
              demo1.push(responseData.energy_generation)
              doc.autoTable({
                body: demo1,
                columns: [{ header: 'Total Month Energy (KWh)', dataKey: 'total_month_energy' },
                { header: 'Specific Yeild (KWh/KWp)', dataKey: 'specific_yeild' },
                ]
              })
            }


            if (responseData.header) {
              var headerArr = [];
              headerArr = Object.keys(responseData.header).map(function (key) {
                return [String(key), responseData.header[key]];
              });

              var dynamicColArr = [];
              for (let i = 0; i < headerArr.length; i++) {
                var key = headerArr[i][1];
                dynamicColArr.push({ header: key, dataKey: "value" + i })
              }
              doc.autoTable({
                body: responseData.generationArr,
                columns: dynamicColArr,
              })
            }
            doc.save(responseData.title + ".pdf");
            this.toastr.success(data.message);
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  download_YearPdf() {
    var UserIdObj = {
      year: this.pipe.transform(this.reportDownloadForm.value.year, 'yyyy'),
      user_id: this.loginName
    }
    this.dashbord.downloadNormalYearPdf(UserIdObj)
      .subscribe(
        async data => {
          if (data.status) {
            var responseData = data.resultObject;
            var b64image = JSON.stringify(responseData.epc_b64image);
            // remove quated string
            var base64Img = b64image.replace(/"/g, '');
            var doc = new jspdf('l', 'pt', 'a4'); //landscape page
            // doc.setFontSize(22);
            // doc.text("Month", 14, 20);
            doc.autoTableSetDefaults({
              didDrawPage: function (data) {
                doc.addImage(base64Img, 'png', data.settings.margin.left, 10, 40, 25);
                doc.text(responseData.company_name, data.settings.margin.left + 43, 22);
                doc.text("Solar generation Yearly Report", data.settings.margin.left + 545, 22);
                doc.setDrawColor(31, 78, 121);
                doc.line(0, 45, 900, 45);
              },
              margin: {
                top: 60,
                bottom: 50
              },
            })

            if (responseData.customer) {
              var demo = []
              demo.push(responseData.customer)
              doc.autoTable({
                body: demo,
                columns: [{ header: 'Customer name', dataKey: 'customer_name' }, { header: 'Plant capacity (KW)', dataKey: 'plant_capacity' },
                { header: 'Address', dataKey: 'address' }, { header: 'Year', dataKey: 'year' }]
              })
            }
            if (responseData.energy_generation) {
              var demo1 = []
              demo1.push(responseData.energy_generation)
              doc.autoTable({
                body: demo1,
                columns: [{ header: 'Total Year Energy (KWh)', dataKey: 'total_year_energy' },
                { header: 'Specific Yeild (KWh/KWp)', dataKey: 'specific_yeild' },]
              })
            }
            if (responseData.header) {
              var headerArr = [];
              headerArr = Object.keys(responseData.header).map(function (key) {
                return [String(key), responseData.header[key]];
              });

              var dynamicColArr = [];
              for (let i = 0; i < headerArr.length; i++) {
                var key = headerArr[i][1];
                dynamicColArr.push({ header: key, dataKey: "value" + i })
              }
              doc.autoTable({
                body: responseData.generationArr,
                columns: dynamicColArr,

              })
            }

            doc.save(responseData.title + ".pdf");
            this.toastr.success(data.message);
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  //solar
  download_DayPdfZESolar() {
    var UserIdObj = {
      date: this.pipe.transform(this.reportDownloadForm.value.dayDate, 'yyyy-MM-dd'),
      user_id: this.loginName
    }
    this.dashbord.downloadZESolarTodaysPdf(UserIdObj)
      .subscribe(
        async data => {
          if (data.status) {
            var responseData = data.resultObject;

            var b64image = JSON.stringify(responseData.epc_b64image);
            // remove quated string
            var base64Img = b64image.replace(/"/g, '');
            var doc = new jspdf('l', 'pt', 'a4'); //landscape page


            doc.autoTableSetDefaults({
              didDrawPage: function (data) {
                doc.addImage(base64Img, 'png', data.settings.margin.left, 10, 40, 25);
                doc.text(responseData.company_name, data.settings.margin.left + 43, 22);
                doc.text("Solar generation Daily Report", data.settings.margin.left + 550, 22);
                doc.setDrawColor(31, 78, 121);
                doc.line(0, 45, 900, 45);
              },
              margin: {
                top: 60,
                bottom: 50
              },
            })

            if (responseData.customer) {
              var demo = []
              demo.push(responseData.customer)
              doc.autoTable({
                body: demo,
                columns: [{ header: 'Customer Name', dataKey: 'customer_name' },
                {
                  header: 'Plant Capacity (KW)',
                  dataKey: 'plant_capacity'
                },
                { header: 'Address', dataKey: 'address' },
                { header: 'Date', dataKey: 'date' }]

              })
            }
            if (responseData.energy_generation) {
              var demo1 = []
              demo1.push(responseData.energy_generation)
              doc.autoTable({
                body: demo1,
                columns: [{ header: 'Daily Energy Generation (KWh)', dataKey: 'daily_energy_generation' },
                { header: 'Total Energy Generation (KWh)', dataKey: 'total_energy_generation' },
                { header: 'Specific Yeild (KWh/KWp)', dataKey: 'specific_yeild' },
                  //  { header:'Pr (%)',dataKey: 'pr' },
                ]
              })
            }
            if (responseData.generationArr) {
              doc.autoTable({
                body: responseData.generationArr,
                columns: [{ header: 'Inverter Name', dataKey: 'inverter_name' },
                { header: 'Daily Energy Generation (KWh)', dataKey: 'daily_energy_generation' },
                { header: 'Total Energy Generation (KWh)', dataKey: 'total_energy_generation' },
                { header: 'Specific Yield (KWh/KWp) ', dataKey: 'specific_yield' }]
              })
            }


            // doc.save("Daily_Report "+ this.pipe.transform(this.reportDownloadForm.value.dayDate, 'yyyy-MM-dd')+'.pdf' );

            doc.save(responseData.title + '.pdf');
            this.toastr.success(data.message);
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // ZE Grid API change 
  download_DayPdfZE() {
    var UserIdObj = {
      date: this.pipe.transform(this.reportDownloadForm.value.dayDate, 'yyyy-MM-dd'),
      user_id: this.loginName
    }
    this.dashbord.downloadZETodaysPdf(UserIdObj)
      .subscribe(
        async data => {
          if (data.status) {
            var responseData = data.resultObject;

            var b64image = JSON.stringify(responseData.epc_b64image);
            // remove quated string
            var base64Img = b64image.replace(/"/g, '');
            var doc = new jspdf('l', 'pt', 'a4'); //landscape page


            doc.autoTableSetDefaults({
              didDrawPage: function (data) {
                doc.addImage(base64Img, 'png', data.settings.margin.left, 10, 40, 25);
                doc.text(responseData.company_name, data.settings.margin.left + 43, 22);
                doc.text("Grid generation Daily Report", data.settings.margin.left + 550, 22);
                doc.setDrawColor(31, 78, 121);
                doc.line(0, 45, 900, 45);
              },
              margin: {
                top: 60,
                bottom: 50
              },
            })

            if (responseData.customer) {
              var demo = []
              demo.push(responseData.customer)
              doc.autoTable({
                body: demo,
                columns: [{ header: 'Customer Name', dataKey: 'customer_name' },
                {
                  header: 'Plant Capacity (KW)',
                  dataKey: 'plant_capacity'
                },
                { header: 'Address', dataKey: 'address' },
                { header: 'Date', dataKey: 'date' }]

              })
            }
            if (responseData.generationArr) {
              doc.autoTable({
                body: responseData.generationArr,
                columns: [{ header: 'Meter Name', dataKey: 'meterName' },
                { header: 'Import', dataKey: 'import' },
                { header: 'Export', dataKey: 'export' }]
              })
            }
            if (responseData.Total) {
              var demo1 = []
              demo1.push(responseData.Total)
              doc.autoTable({
                body: demo1,
                columns: [
                  { header: 'Total', dataKey: 'total' },
                  { header: 'Import Total', dataKey: 'import_total' },
                  { header: 'Export Total', dataKey: 'export_total' },
                ],
              })
            }

            doc.save(responseData.title + '.pdf');
            this.toastr.success(data.message);
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  // DG Grid API change 
  download_DayPdfDGGrid() {
    var UserIdObj = {
      date: this.pipe.transform(this.reportDownloadForm.value.dayDate, 'yyyy-MM-dd'),
      user_id: this.loginName
    }
    this.dashbord.downloadDGGridTodaysPdf(UserIdObj)
      .subscribe(
        async data => {
          if (data.status) {
            var responseData = data.resultObject;

            var b64image = JSON.stringify(responseData.epc_b64image);
            // remove quated string
            var base64Img = b64image.replace(/"/g, '');
            var doc = new jspdf('l', 'pt', 'a4'); //landscape page


            doc.autoTableSetDefaults({
              didDrawPage: function (data) {
                doc.addImage(base64Img, 'png', data.settings.margin.left, 10, 40, 25);
                doc.text(responseData.company_name, data.settings.margin.left + 43, 22);
                doc.text("Grid generation Daily Report", data.settings.margin.left + 550, 22);
                doc.setDrawColor(31, 78, 121);
                doc.line(0, 45, 900, 45);
              },
              margin: {
                top: 60,
                bottom: 50
              },
            })

            if (responseData.customer) {
              var demo = []
              demo.push(responseData.customer)
              doc.autoTable({
                body: demo,
                columns: [{ header: 'Customer Name', dataKey: 'customer_name' },
                {
                  header: 'Plant Capacity (KW)',
                  dataKey: 'plant_capacity'
                },
                { header: 'Address', dataKey: 'address' },
                { header: 'Date', dataKey: 'date' }]

              })
            }
            if (responseData.generationArr) {
              doc.autoTable({
                body: responseData.generationArr,
                columns: [{ header: 'Meter Name', dataKey: 'meterName' },
                { header: 'Import', dataKey: 'import' },
                { header: 'Export', dataKey: 'export' }]
              })
            }
            if (responseData.Total) {
              var demo1 = []
              demo1.push(responseData.Total)
              doc.autoTable({
                body: demo1,
                columns: [
                   { header: 'Total', dataKey: 'total' },
                  { header: 'Import Total', dataKey: 'import_total' },
                { header: 'Export Total', dataKey: 'export_total' },
                ]
              })
            }
            if (responseData.Grid_outage) {
              var demo2 = []
              demo2.push(responseData.Grid_outage)
              doc.autoTable({
                body: demo2,
                columns: [{ header: 'Grid outage (In minutes)', dataKey: 'Grid_outage_cal' }]
              })
            }



            // doc.save("Daily_Report "+ this.pipe.transform(this.reportDownloadForm.value.dayDate, 'yyyy-MM-dd')+'.pdf' );

            doc.save(responseData.title + '.pdf');
            this.toastr.success(data.message);
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // DG User DG Download day Report 
  download_DayPdfDG() {
    var UserIdObj = {
      date: this.pipe.transform(this.reportDownloadForm.value.dayDate, 'yyyy-MM-dd'),
      user_id: this.loginName
    }
    this.dashbord.downloadDGTodaysPdf(UserIdObj)
      .subscribe(
        async data => {
          if (data.status) {
            var responseData = data.resultObject;

            var b64image = JSON.stringify(responseData.epc_b64image);
            // remove quated string
            var base64Img = b64image.replace(/"/g, '');
            var doc = new jspdf('l', 'pt', 'a4'); //landscape page


            doc.autoTableSetDefaults({
              didDrawPage: function (data) {
                doc.addImage(base64Img, 'png', data.settings.margin.left, 10, 40, 25);
                doc.text(responseData.company_name, data.settings.margin.left + 43, 22);
                doc.text("DG generation Daily Report", data.settings.margin.left + 550, 22);
                doc.setDrawColor(31, 78, 121);
                doc.line(0, 45, 900, 45);
              },
              margin: {
                top: 60,
                bottom: 50
              },
            })

            if (responseData.customer) {
              var demo = []
              demo.push(responseData.customer)
              doc.autoTable({
                body: demo,
                columns: [{ header: 'Customer Name', dataKey: 'customer_name' },
                {
                  header: 'Plant Capacity (KW)',
                  dataKey: 'plant_capacity'
                },
                { header: 'Address', dataKey: 'address' },
                { header: 'Date', dataKey: 'date' }]

              })
            }

            if (responseData.generationArr) {
              doc.autoTable({
                body: responseData.generationArr,
                columns: [{ header: 'Meter Name', dataKey: 'meterName' },
                { header: 'DG energy(KWh)', dataKey: 'dg_energy' },
                { header: 'DG Run Time', dataKey: 'DG Run Time' },
                { header: 'DG1', dataKey: 'DG1' },
                { header: 'DG2', dataKey: 'DG2' },
                { header: 'DG3', dataKey: 'DG3' },
                { header: 'DG4', dataKey: 'DG4' }]
              })
            }

            if (responseData.Total) {
              var demo1 = []
              demo1.push(responseData.Total)
              doc.autoTable({
                body: demo1,
                columns: [{ header: 'Total Energy', dataKey: 'total_energy' },
                { header: 'Total', dataKey: 'total' }]
              })
            }


            // doc.save("Daily_Report "+ this.pipe.transform(this.reportDownloadForm.value.dayDate, 'yyyy-MM-dd')+'.pdf' );

            doc.save(responseData.title + '.pdf');
            this.toastr.success(data.message);
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // DG user Load Download Today's Repoer
  download_DayPdfDGLoad() {
    var UserIdObj = {
      date: this.pipe.transform(this.reportDownloadForm.value.dayDate, 'yyyy-MM-dd'),
      user_id: this.loginName
    }
    this.dashbord.downloadDGLoadTodaysPdf(UserIdObj)
      .subscribe(
        async data => {
          if (data.status) {
            var responseData = data.resultObject;

            var b64image = JSON.stringify(responseData.epc_b64image);
            // remove quated string
            var base64Img = b64image.replace(/"/g, '');
            var doc = new jspdf('l', 'pt', 'a4'); //landscape page


            doc.autoTableSetDefaults({
              didDrawPage: function (data) {
                doc.addImage(base64Img, 'png', data.settings.margin.left, 10, 40, 25);
                doc.text(responseData.company_name, data.settings.margin.left + 43, 22);
                doc.text("Load generation Daily Report", data.settings.margin.left + 550, 22);
                doc.setDrawColor(31, 78, 121);
                doc.line(0, 45, 900, 45);
              },
              margin: {
                top: 60,
                bottom: 50
              },
            })

            if (responseData.customer) {
              var demo = []
              demo.push(responseData.customer)
              doc.autoTable({
                body: demo,
                columns: [{ header: 'Customer Name', dataKey: 'customer_name' },
                {
                  header: 'Plant Capacity (KW)',
                  dataKey: 'plant_capacity'
                },
                { header: 'Address', dataKey: 'address' },
                { header: 'Date', dataKey: 'date' }]

              })
            }

            if (responseData.generationArr) {
              doc.autoTable({
                body: responseData.generationArr,
                columns: [{ header: 'Meter Name', dataKey: 'meterName' },
                { header: 'Load Power Consumption', dataKey: 'load_power_consumption' }]
              })
            }
            if (responseData.Total) {
              var demo1 = []
              demo1.push(responseData.Total)
              doc.autoTable({
                body: demo1,
                columns: [{ header: 'Total', dataKey: 'total' },
                { header: 'Energy Consumption( in KWh)', dataKey: 'total_energy_consumption' }
                ]
              })
            }


            // doc.save("Daily_Report "+ this.pipe.transform(this.reportDownloadForm.value.dayDate, 'yyyy-MM-dd')+'.pdf' );

            doc.save(responseData.title + '.pdf');
            this.toastr.success(data.message);
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // DG User plant download today report
  download_DayPdfDGPlant() {

    var UserIdObj = {
      date: this.pipe.transform(this.reportDownloadForm.value.dayDate, 'yyyy-MM-dd'),
      user_id: this.loginName
    }
    this.dashbord.downloadDGPlantTodaysPdf(UserIdObj)
      .subscribe(
        async data => {
          if (data.status) {
            var responseData = data.resultObject;

            var b64image = JSON.stringify(responseData.epc_b64image);
            // remove quated string
            var base64Img = b64image.replace(/"/g, '');
            var doc = new jspdf('l', 'pt', 'a4'); //landscape page


            doc.autoTableSetDefaults({
              didDrawPage: function (data) {
                doc.addImage(base64Img, 'png', data.settings.margin.left, 10, 40, 25);
                doc.text(responseData.company_name, data.settings.margin.left + 43, 22);
                doc.text("Plant generation Daily Report", data.settings.margin.left + 550, 22);
                doc.setDrawColor(31, 78, 121);
                doc.line(0, 45, 900, 45);
              },
              margin: {
                top: 60,
                bottom: 50
              },
            })

            if (responseData.customer) {
              var demo = []
              demo.push(responseData.customer)
              doc.autoTable({
                body: demo,
                columns: [{ header: 'Customer Name', dataKey: 'customer_name' },
                {
                  header: 'Plant Capacity (KW)',
                  dataKey: 'plant_capacity'
                },
                { header: 'Address', dataKey: 'address' },
                { header: 'Date', dataKey: 'date' }]

              })
            }
            if (responseData) {
              var demo1 = []
              demo1.push(responseData)
              doc.autoTable({
                body: demo1,
                columns: [{ header: 'Solar Generation', dataKey: 'solar generation' },
                { header: 'Imported Grid Energy', dataKey: 'Imported Grid Energy' },
                { header: 'Exported Grid Energy', dataKey: 'Exported Grid Energy' },
                { header: 'Captive solar consumption', dataKey: 'captive solar consumption' },
                { header: 'Specific Yeild', dataKey: 'Specific Yeild' },
                { header: 'Load energy consumption', dataKey: 'load energy consumption' },
                { header: 'DG Energy Generation', dataKey: 'DG Energy Generation' },
                { header: 'Solar genration During DG', dataKey: 'Solar genration During DG' },
                { header: 'DG run time', dataKey: 'DG run time' },
                { header: 'DG1', dataKey: 'DG1' },
                { header: 'DG2', dataKey: 'DG2' },
                { header: 'DG3', dataKey: 'DG3' },
                { header: 'DG4', dataKey: 'DG4' },
                { header: 'Grid Outage(in minutes) During (4 AM to 8 PM)', dataKey: 'Grid Outage(in minutes) During (4 AM to 8 PM)' },
                { header: 'Load consumption During Grid Outage', dataKey: 'Load consumption During Grid Outage' }
                ]
              })
            }


            // doc.save("Daily_Report "+ this.pipe.transform(this.reportDownloadForm.value.dayDate, 'yyyy-MM-dd')+'.pdf' );

            doc.save(responseData.title + '.pdf');
            this.toastr.success(data.message);
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  // ZE User Load download today report (Arun)
  download_DayPdfLoad() {
    var UserIdObj = {
      date: this.pipe.transform(this.reportDownloadForm.value.dayDate, 'yyyy-MM-dd'),
      user_id: this.loginName
    }
    this.dashbord.downloadLoadTodaysPdf(UserIdObj)
      .subscribe(
        async data => {
          if (data.status) {
            var responseData = data.resultObject;

            var b64image = JSON.stringify(responseData.epc_b64image);
            // remove quated string
            var base64Img = b64image.replace(/"/g, '');
            var doc = new jspdf('l', 'pt', 'a4'); //landscape page


            doc.autoTableSetDefaults({
              didDrawPage: function (data) {
                doc.addImage(base64Img, 'png', data.settings.margin.left, 10, 40, 25);
                doc.text(responseData.company_name, data.settings.margin.left + 43, 22);
                doc.text("Load generation Daily Report", data.settings.margin.left + 550, 22);
                doc.setDrawColor(31, 78, 121);
                doc.line(0, 45, 900, 45);
              },
              margin: {
                top: 60,
                bottom: 50
              },
            })

            if (responseData.customer) {
              var demo = []
              demo.push(responseData.customer)
              doc.autoTable({
                body: demo,
                columns: [{ header: 'Customer Name', dataKey: 'customer_name' },
                {
                  header: 'Plant Capacity (KW)',
                  dataKey: 'plant_capacity'
                },
                { header: 'Address', dataKey: 'address' },
                { header: 'Date', dataKey: 'date' }]

              })
            }

            if (responseData.generationArr) {
              doc.autoTable({
                body: responseData.generationArr,
                columns: [{ header: 'Meter Name', dataKey: 'meterName' },
                { header: 'Load Power Consumption', dataKey: 'load_power_consumption' }]
              })
            }

            if (responseData.Total) {
              var demo1 = []
              demo1.push(responseData.Total)
              doc.autoTable({
                body: demo1,
                columns: [
                  { header: 'Total', dataKey: 'total' },
                  { header: 'Total energy consumption (in KWH)', dataKey: 'total_energy_consumption' }
                ]
              })
            }


            // doc.save("Daily_Report "+ this.pipe.transform(this.reportDownloadForm.value.dayDate, 'yyyy-MM-dd')+'.pdf' );

            doc.save(responseData.title + '.pdf');
            this.toastr.success(data.message);
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  // ZE User Plant download today report (Arun)
  download_DayPdfPlant() {
    var UserIdObj = {
      date: this.pipe.transform(this.reportDownloadForm.value.dayDate, 'yyyy-MM-dd'),
      user_id: this.loginName
    }
    this.dashbord.downloadPlantTodaysPdf(UserIdObj)
      .subscribe(
        async data => {
          if (data.status) {
            var responseData = data.resultObject;

            var b64image = JSON.stringify(responseData.epc_b64image);
            // remove quated string
            var base64Img = b64image.replace(/"/g, '');
            var doc = new jspdf('l', 'pt', 'a4'); //landscape page


            doc.autoTableSetDefaults({
              didDrawPage: function (data) {
                doc.addImage(base64Img, 'png', data.settings.margin.left, 10, 40, 25);
                doc.text(responseData.company_name, data.settings.margin.left + 43, 22);
                doc.text("Solar generation Daily Report", data.settings.margin.left + 550, 22);
                doc.setDrawColor(31, 78, 121);
                doc.line(0, 45, 900, 45);
              },
              margin: {
                top: 60,
                bottom: 50
              },
            })

            if (responseData.customer) {
              var demo = []
              demo.push(responseData.customer)
              doc.autoTable({
                body: demo,
                columns: [{ header: 'Customer Name', dataKey: 'customer_name' },
                {
                  header: 'Plant Capacity (KW)',
                  dataKey: 'plant_capacity'
                },
                { header: 'Address', dataKey: 'address' },
                { header: 'Date', dataKey: 'date' }]

              })
            }
            if (responseData) {
              var demo1 = []
              demo1.push(responseData)
              doc.autoTable({
                body: demo1,
                columns: [{ header: 'Solar Generation', dataKey: 'solar generation' },
                { header: 'Imported Grid Energy', dataKey: 'Imported Grid Energy' },
                { header: 'Exported Grid Energy', dataKey: 'Exported Grid Energy' },
                { header: 'Captive solar consumption', dataKey: 'captive solar consumption' },
                { header: 'Specific Yeild', dataKey: 'Specific Yeild' },
                { header: 'Load energy consumption', dataKey: 'load energy consumption' },
                { header: 'Insolation (KWh/m2)', dataKey: 'INS' },
                { header: 'Pr (%)', dataKey: 'PR' }
                ]
              })
            }


            // doc.save("Daily_Report "+ this.pipe.transform(this.reportDownloadForm.value.dayDate, 'yyyy-MM-dd')+'.pdf' );

            doc.save(responseData.title + '.pdf');
            this.toastr.success(data.message);
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  // All month API start
  downloadReportZESolar() {
    var UserIdObj = {
      month: this.pipe.transform(this.reportDownloadForm.value.monthYear, 'MM'),
      year: this.pipe.transform(this.reportDownloadForm.value.monthYear, 'yyyy'),
      user_id: this.loginName
    }
    this.dashbord.downloadZEMonthPdf(UserIdObj)
      .subscribe(
        async data => {
          if (data.status) {
            var responseData = data.resultObject;
            var b64image = JSON.stringify(responseData.epc_b64image);
            // remove quated string
            var base64Img = b64image.replace(/"/g, '');
            var doc = new jspdf('l', 'pt', 'a4'); //landscape page
            doc.autoTableSetDefaults({
              didDrawPage: function (data) {
                doc.addImage(base64Img, 'png', data.settings.margin.left, 10, 40, 25);
                doc.text(responseData.company_name, data.settings.margin.left + 43, 22);
                doc.text("Solar generation Monthly Report", data.settings.margin.left + 535, 22);
                doc.setDrawColor(31, 78, 121);
                doc.line(0, 45, 900, 45);
              },
              margin: {
                top: 60,
                bottom: 50
              },
            })


            if (responseData.customer) {
              var demo = []
              demo.push(responseData.customer)
              demo[0].month = this.pipe.transform(this.reportDownloadForm.value.monthYear, 'MMMM')
              doc.autoTable({
                body: demo,
                columns: [{ header: 'Customer Name', dataKey: 'customer_name' }, { header: 'Plant Capacity (KW)', dataKey: 'plant_capacity' },
                { header: 'Address', dataKey: 'address' }, { header: 'Month', dataKey: 'month' }]
              })
            }
            // header first
            if (responseData.header) {
              var headerArr1 = [];
              headerArr1 = Object.keys(responseData.header).map(function (key) {
                return [String(key), responseData.header[key]];
              });

              var dynamicColArr1 = [];
              for (let i = 0; i < headerArr1.length; i++) {
                var key = headerArr1[i][1];
                dynamicColArr1.push({ header: key, dataKey: "value" + i })
              }
              doc.autoTable({
                body: responseData.generationArr,
                columns: dynamicColArr1,

              })
            }
            // if (responseData.headerSec) {

            //   var headerArr = [];
            //   headerArr = Object.keys(responseData.headerSec).map(function (key) {
            //     return [String(key), responseData.headerSec[key]];
            //   });

            //   var dynamicColArr = [];
            //   for (let i = 0; i < headerArr.length; i++) {
            //     var key = headerArr[i][1];
            //     dynamicColArr.push({ header: key, dataKey: "value" + i })
            //   }
            //   console.log('dynamicColArr',dynamicColArr)
            //   doc.autoTable({
            //     body: responseData.generationArr,
            //     columns: dynamicColArr,

            //   })
            // }
            doc.save(responseData.title + ".pdf");
            this.toastr.success(data.message);
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  // Grid month ZE
  downloadReportZEGrid() {
    var UserIdObj = {
      month: this.pipe.transform(this.reportDownloadForm.value.monthYear, 'MM'),
      year: this.pipe.transform(this.reportDownloadForm.value.monthYear, 'yyyy'),
      user_id: this.loginName
    }
    this.dashbord.downloadZEMonthGridPdf(UserIdObj)
      .subscribe(
        async data => {
          if (data.status) {
            var responseData = data.resultObject;
            var b64image = JSON.stringify(responseData.epc_b64image);
            // remove quated string
            var base64Img = b64image.replace(/"/g, '');
            var doc = new jspdf('l', 'pt', 'a4'); //landscape page
            doc.autoTableSetDefaults({
              didDrawPage: function (data) {
                doc.addImage(base64Img, 'png', data.settings.margin.left, 10, 40, 25);
                doc.text(responseData.company_name, data.settings.margin.left + 43, 22);
                doc.text("Grid generation Monthly Report", data.settings.margin.left + 535, 22);
                doc.setDrawColor(31, 78, 121);
                doc.line(0, 45, 900, 45);
              },
              margin: {
                top: 60,
                bottom: 50
              },
            })


            if (responseData.customer) {
              var demo = []
              demo.push(responseData.customer)
              doc.autoTable({
                body: demo,
                columns: [{ header: 'Customer Name', dataKey: 'customer_name' }, { header: 'Plant Capacity (KW)', dataKey: 'plant_capacity' },
                { header: 'Address', dataKey: 'address' }, { header: 'Date', dataKey: 'date' }]
              })
            }
            // header first
            if (responseData.header) {
              var headerArr1 = [];
              headerArr1 = Object.keys(responseData.header).map(function (key) {
                return [String(key), responseData.header[key]];
              });

              var dynamicColArr1 = [];
              for (let i = 0; i < headerArr1.length; i++) {
                var key = headerArr1[i][1];
                dynamicColArr1.push({ header: key, dataKey: "value" + i })
              }
              doc.autoTable({
                columns: dynamicColArr1,

              })
            }
            if (responseData.headerSec) {
              var headerArr = [];
              headerArr = Object.keys(responseData.headerSec).map(function (key) {
                return [String(key), responseData.headerSec[key]];
              });

              var dynamicColArr = [];
              for (let i = 0; i < headerArr.length; i++) {
                var key = headerArr[i][1];
                dynamicColArr.push({ header: key, dataKey: "value" + i })
              }
              doc.autoTable({
                body: responseData.generationArr,
                columns: dynamicColArr,

              })
            }
            doc.save(responseData.title + ".pdf");
            this.toastr.success(data.message);
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // load month ZE
  downloadMonthPdfZELoad() {
    var UserIdObj = {
      month: this.pipe.transform(this.reportDownloadForm.value.monthYear, 'MM'),
      year: this.pipe.transform(this.reportDownloadForm.value.monthYear, 'yyyy'),
      user_id: this.loginName
    }
    this.dashbord.downloadZEMonthLoadPdf(UserIdObj)
      .subscribe(
        async data => {
          if (data.status) {
            var responseData = data.resultObject;
            var b64image = JSON.stringify(responseData.epc_b64image);
            // remove quated string
            var base64Img = b64image.replace(/"/g, '');
            var doc = new jspdf('l', 'pt', 'a4'); //landscape page
            doc.autoTableSetDefaults({
              didDrawPage: function (data) {
                doc.addImage(base64Img, 'png', data.settings.margin.left, 10, 40, 25);
                doc.text(responseData.company_name, data.settings.margin.left + 43, 22);
                doc.text("Load generation Monthly Report", data.settings.margin.left + 535, 22);
                doc.setDrawColor(31, 78, 121);
                doc.line(0, 45, 900, 45);
              },
              margin: {
                top: 60,
                bottom: 50
              },
            })


            if (responseData.customer) {
              var demo = []
              demo.push(responseData.customer)
              doc.autoTable({
                body: demo,
                columns: [{ header: 'Customer Name', dataKey: 'customer_name' }, { header: 'Plant Capacity (KW)', dataKey: 'plant_capacity' },
                { header: 'Address', dataKey: 'address' }, { header: 'Date', dataKey: 'date' }]
              })
            }
            // header first
            if (responseData.header) {
              var headerArr1 = [];
              headerArr1 = Object.keys(responseData.header).map(function (key) {
                return [String(key), responseData.header[key]];
              });

              var dynamicColArr1 = [];
              for (let i = 0; i < headerArr1.length; i++) {
                var key = headerArr1[i][1];
                dynamicColArr1.push({ header: key, dataKey: "value" + i })
              }
              doc.autoTable({
                columns: dynamicColArr1,

              })
            }
            if (responseData.headerSec) {
              var headerArr = [];
              headerArr = Object.keys(responseData.headerSec).map(function (key) {
                return [String(key), responseData.headerSec[key]];
              });

              var dynamicColArr = [];
              for (let i = 0; i < headerArr.length; i++) {
                var key = headerArr[i][1];
                dynamicColArr.push({ header: key, dataKey: "value" + i })
              }
              doc.autoTable({
                body: responseData.generationArr,
                columns: dynamicColArr,

              })
            }
            doc.save(responseData.title + ".pdf");
            this.toastr.success(data.message);
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  // plant Month ZE
  downloadMonthPdfZEPlant() {
    var UserIdObj = {
      month: this.pipe.transform(this.reportDownloadForm.value.monthYear, 'MM'),
      year: this.pipe.transform(this.reportDownloadForm.value.monthYear, 'yyyy'),
      user_id: this.loginName
    }
    this.dashbord.downloadZEMonthPlantPdf(UserIdObj)
      .subscribe(
        async data => {
          if (data.status) {
            var responseData = data.resultObject;
            var b64image = JSON.stringify(responseData.epc_b64image);
            // remove quated string
            var base64Img = b64image.replace(/"/g, '');
            var doc = new jspdf('l', 'pt', 'a4'); //landscape page
            doc.autoTableSetDefaults({
              didDrawPage: function (data) {
                doc.addImage(base64Img, 'png', data.settings.margin.left, 10, 40, 25);
                doc.text(responseData.company_name, data.settings.margin.left + 43, 22);
                doc.text("Plant generation Monthly Report", data.settings.margin.left + 535, 22);
                doc.setDrawColor(31, 78, 121);
                doc.line(0, 45, 900, 45);
              },
              margin: {
                top: 60,
                bottom: 50
              },
            })


            if (responseData.customer) {
              var demo = []
              demo.push(responseData.customer)
              doc.autoTable({
                body: demo,
                columns: [{ header: 'Customer Name', dataKey: 'customer_name' }, { header: 'Plant Capacity (KW)', dataKey: 'plant_capacity' },
                { header: 'Address', dataKey: 'address' }, { header: 'Date', dataKey: 'date' }]
              })
            }
            // header first
            // if (responseData.header) {
            //   var headerArr1 = [];
            //   headerArr1 = Object.keys(responseData.header).map(function (key) {
            //     return [String(key), responseData.header[key]];
            //   });

            //   var dynamicColArr1 = [];
            //   for (let i = 0; i < headerArr1.length; i++) {
            //     var key = headerArr1[i][1];
            //     dynamicColArr1.push({ header: key,  dataKey: "value" + i })
            //   }
            //   doc.autoTable({
            //     columns: dynamicColArr1,

            //   })
            // }
            if (responseData.header) {
              var headerArr = [];
              headerArr = Object.keys(responseData.header).map(function (key) {
                return [String(key), responseData.header[key]];
              });

              var dynamicColArr = [];
              for (let i = 0; i < headerArr.length; i++) {
                var key = headerArr[i][1];
                dynamicColArr.push({ header: key, dataKey: "value" + i })
              }
              doc.autoTable({
                body: responseData.generationArr,
                columns: dynamicColArr,

              })
            }
            doc.save(responseData.title + ".pdf");
            this.toastr.success(data.message);
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // DG Month DG
  downloadReportDGGrid() {
    var UserIdObj = {
      month: this.pipe.transform(this.reportDownloadForm.value.monthYear, 'MM'),
      year: this.pipe.transform(this.reportDownloadForm.value.monthYear, 'yyyy'),
      user_id: this.loginName
    }
    this.dashbord.downloadDGMonthPlantPdf(UserIdObj)
      .subscribe(
        async data => {
          if (data.status) {
            var responseData = data.resultObject;
            var b64image = JSON.stringify(responseData.epc_b64image);
            // remove quated string
            var base64Img = b64image.replace(/"/g, '');
            var doc = new jspdf('l', 'pt', 'a4'); //landscape page
            doc.autoTableSetDefaults({
              didDrawPage: function (data) {
                doc.addImage(base64Img, 'png', data.settings.margin.left, 10, 40, 25);
                doc.text(responseData.company_name, data.settings.margin.left + 43, 22);
                doc.text("Grid generation Monthly Report", data.settings.margin.left + 535, 22);
                doc.setDrawColor(31, 78, 121);
                doc.line(0, 45, 900, 45);
              },
              margin: {
                top: 60,
                bottom: 50
              },
            })


            if (responseData.customer) {
              var demo = []
              demo.push(responseData.customer)
              doc.autoTable({
                body: demo,
                columns: [{ header: 'Customer Name', dataKey: 'customer_name' }, { header: 'Plant Capacity (KW)', dataKey: 'plant_capacity' },
                { header: 'Address', dataKey: 'address' }, { header: 'Date', dataKey: 'date' }]
              })
            }
            // header first
            if (responseData.header) {
              var headerArr1 = [];
              headerArr1 = Object.keys(responseData.header).map(function (key) {
                return [String(key), responseData.header[key]];
              });

              var dynamicColArr1 = [];
              for (let i = 0; i < headerArr1.length; i++) {
                var key = headerArr1[i][1];
                dynamicColArr1.push({ header: key, dataKey: "value" + i })
              }
              doc.autoTable({
                body: responseData.generationArr,
                columns: dynamicColArr1,
              })
            }
            if (responseData.headerSec) {
              var headerArr = [];
              headerArr = Object.keys(responseData.headerSec).map(function (key) {
                return [String(key), responseData.headerSec[key]];
              });

              var dynamicColArr = [];
              for (let i = 0; i < headerArr.length; i++) {
                var key = headerArr[i][1];
                dynamicColArr.push({ header: key, dataKey: "value" + i })
              }
              doc.autoTable({
                body: responseData.generationArr,
                columns: dynamicColArr,

              })
            }
            doc.save(responseData.title + ".pdf");
            this.toastr.success(data.message);
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }


  // All month API end
  download_MonthPdfZE() {
    var UserIdObj = {
      month: this.pipe.transform(this.reportDownloadForm.value.monthYear, 'MM'),
      year: this.pipe.transform(this.reportDownloadForm.value.monthYear, 'yyyy'),
      user_id: this.loginName
    }
    this.dashbord.downloadZEMonthPdf(UserIdObj)
      .subscribe(
        async data => {
          if (data.status) {
            var responseData = data.resultObject;
            var b64image = JSON.stringify(responseData.epc_b64image);
            // remove quated string
            var base64Img = b64image.replace(/"/g, '');
            var doc = new jspdf('l', 'pt', 'a4'); //landscape page
            doc.autoTableSetDefaults({
              didDrawPage: function (data) {
                doc.addImage(base64Img, 'png', data.settings.margin.left, 10, 40, 25);
                doc.text(responseData.company_name, data.settings.margin.left + 43, 22);
                doc.text("Solar generation Monthly Report", data.settings.margin.left + 535, 22);
                doc.setDrawColor(31, 78, 121);
                doc.line(0, 45, 900, 45);
              },
              margin: {
                top: 60,
                bottom: 50
              },
            })
            if (responseData.customer) {
              var demo = []
              demo.push(responseData.customer)
              doc.autoTable({
                body: demo,
                columns: [{ header: 'Customer Name', dataKey: 'customer_name' }, { header: 'Plant Capacity (KW)', dataKey: 'plant_capacity' },
                { header: 'Address', dataKey: 'address' }, { header: 'Date', dataKey: 'month' }]
              })
            }
            if (responseData.energy_generation) {
              var demo1 = []
              demo1.push(responseData.energy_generation)
              doc.autoTable({
                body: demo1,
                columns: [{ header: 'Total Month Energy (KWh)', dataKey: 'total_month_energy' },
                { header: 'Specific Yeild (KWh/KWp)', dataKey: 'specific_yeild' },
                ]
              })
            }


            if (responseData.header) {
              var headerArr = [];
              headerArr = Object.keys(responseData.header).map(function (key) {
                return [String(key), responseData.header[key]];
              });

              var dynamicColArr = [];
              for (let i = 0; i < headerArr.length; i++) {
                var key = headerArr[i][1];
                dynamicColArr.push({ header: key, dataKey: "value" + i })
              }
              doc.autoTable({
                body: responseData.generationArr,
                columns: dynamicColArr,
              })
            }
            doc.save(responseData.title + ".pdf");
            this.toastr.success(data.message);
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  download_YearPdfZE() {
    var UserIdObj = {
      year: this.pipe.transform(this.reportDownloadForm.value.year, 'yyyy'),
      user_id: this.loginName
    }
    this.dashbord.downloadZEYearPdf(UserIdObj)
      .subscribe(
        async data => {
          if (data.status) {
            var responseData = data.resultObject;
            var b64image = JSON.stringify(responseData.epc_b64image);
            // remove quated string
            var base64Img = b64image.replace(/"/g, '');
            var doc = new jspdf('l', 'pt', 'a4'); //landscape page
            // doc.setFontSize(22);
            // doc.text("Month", 14, 20);
            doc.autoTableSetDefaults({
              didDrawPage: function (data) {
                doc.addImage(base64Img, 'png', data.settings.margin.left, 10, 40, 25);
                doc.text(responseData.company_name, data.settings.margin.left + 43, 22);
                doc.text("Solar generation Yearly Report", data.settings.margin.left + 545, 22);
                doc.setDrawColor(31, 78, 121);
                doc.line(0, 45, 900, 45);
              },
              margin: {
                top: 60,
                bottom: 50
              },
            })

            if (responseData.customer) {
              var demo = []
              demo.push(responseData.customer)
              doc.autoTable({
                body: demo,
                columns: [{ header: 'Customer name', dataKey: 'customer_name' }, { header: 'Plant capacity (KW)', dataKey: 'plant_capacity' },
                { header: 'Address', dataKey: 'address' }, { header: 'Year', dataKey: 'year' }]
              })
            }
            if (responseData.energy_generation) {
              var demo1 = []
              demo1.push(responseData.energy_generation)
              doc.autoTable({
                body: demo1,
                columns: [{ header: 'Total Year Energy (KWh)', dataKey: 'total_month_energy' },
                { header: 'Specific Yeild (KWh/KWp)', dataKey: 'specific_yeild' },]
              })
            }
            if (responseData.header) {
              var headerArr = [];
              headerArr = Object.keys(responseData.header).map(function (key) {
                return [String(key), responseData.header[key]];
              });

              var dynamicColArr = [];
              for (let i = 0; i < headerArr.length; i++) {
                var key = headerArr[i][1];
                dynamicColArr.push({ header: key, dataKey: "value" + i })
              }
              doc.autoTable({
                body: responseData.generationArr,
                columns: dynamicColArr,

              })
            }

            doc.save(responseData.title + ".pdf");
            this.toastr.success(data.message);
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  // dgZe api integtation Year

  downloadReportYeasrZEGrid() {
    var UserIdObj = {
      year: this.pipe.transform(this.reportDownloadForm.value.year, 'yyyy'),
      user_id: this.loginName
    }
    this.dashbord.downloadZEYearPdfZEGrid(UserIdObj)
      .subscribe(
        async data => {
          if (data.status) {
            var responseData = data.resultObject;
            var b64image = JSON.stringify(responseData.epc_b64image);
            // remove quated string
            var base64Img = b64image.replace(/"/g, '');
            var doc = new jspdf('l', 'pt', 'a4'); //landscape page
            // doc.setFontSize(22);
            // doc.text("Month", 14, 20);
            doc.autoTableSetDefaults({
              didDrawPage: function (data) {
                doc.addImage(base64Img, 'png', data.settings.margin.left, 10, 40, 25);
                doc.text(responseData.company_name, data.settings.margin.left + 43, 22);
                doc.text("Grid generation Yearly Report", data.settings.margin.left + 545, 22);
                doc.setDrawColor(31, 78, 121);
                doc.line(0, 45, 900, 45);
              },
              margin: {
                top: 60,
                bottom: 50
              },
            })

            if (responseData.customer) {
              var demo = []
              demo.push(responseData.customer)
              doc.autoTable({
                body: demo,
                columns: [{ header: 'Customer name', dataKey: 'customer_name' }, { header: 'Plant capacity (KW)', dataKey: 'plant_capacity' },
                { header: 'Address', dataKey: 'address' }, { header: 'Year', dataKey: 'year' }]
              })
            }
            // if (responseData.energy_generation) {
            //   var demo1 = []
            //   demo1.push(responseData.energy_generation)
            //   doc.autoTable({
            //     body: demo1,
            //     columns: [{ header: 'Total Year Energy (KWh)', dataKey: 'total_year_energy' },
            //     { header: 'Specific Yeild (KWh/KWp)', dataKey: 'specific_yeild' },]
            //   })
            // }

            // header first
            if (responseData.header) {
              var headerArr1 = [];
              headerArr1 = Object.keys(responseData.header).map(function (key) {
                return [String(key), responseData.header[key]];
              });

              var dynamicColArr1 = [];
              for (let i = 0; i < headerArr1.length; i++) {
                var key = headerArr1[i][1];
                dynamicColArr1.push({ header: key, dataKey: "value" + i })
              }
              doc.autoTable({
                columns: dynamicColArr1,

              })
            }

            if (responseData.headerSec) {
              var headerArr = [];
              headerArr = Object.keys(responseData.headerSec).map(function (key) {
                return [String(key), responseData.headerSec[key]];
              });

              var dynamicColArr = [];
              for (let i = 0; i < headerArr.length; i++) {
                var key = headerArr[i][1];
                dynamicColArr.push({ header: key, dataKey: "value" + i })
              }
              doc.autoTable({
                body: responseData.generationArr,
                columns: dynamicColArr,

              })
            }

            doc.save(responseData.title + ".pdf");
            this.toastr.success(data.message);
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  downloadReportYeasrZELoad() {
    var UserIdObj = {
      year: this.pipe.transform(this.reportDownloadForm.value.year, 'yyyy'),
      user_id: this.loginName
    }
    this.dashbord.downloadZEYearPdfZELoad(UserIdObj)
      .subscribe(
        async data => {
          if (data.status) {
            var responseData = data.resultObject;
            var b64image = JSON.stringify(responseData.epc_b64image);
            // remove quated string
            var base64Img = b64image.replace(/"/g, '');
            var doc = new jspdf('l', 'pt', 'a4'); //landscape page
            // doc.setFontSize(22);
            // doc.text("Month", 14, 20);
            doc.autoTableSetDefaults({
              didDrawPage: function (data) {
                doc.addImage(base64Img, 'png', data.settings.margin.left, 10, 40, 25);
                doc.text(responseData.company_name, data.settings.margin.left + 43, 22);
                doc.text("Load generation Yearly Report", data.settings.margin.left + 545, 22);
                doc.setDrawColor(31, 78, 121);
                doc.line(0, 45, 900, 45);
              },
              margin: {
                top: 60,
                bottom: 50
              },
            })

            if (responseData.customer) {
              var demo = []
              demo.push(responseData.customer)
              doc.autoTable({
                body: demo,
                columns: [{ header: 'Customer name', dataKey: 'customer_name' }, { header: 'Plant capacity (KW)', dataKey: 'plant_capacity' },
                { header: 'Address', dataKey: 'address' }, { header: 'Year', dataKey: 'year' }]
              })
            }
            // if (responseData.energy_generation) {
            //   var demo1 = []
            //   demo1.push(responseData.energy_generation)
            //   doc.autoTable({
            //     body: demo1,
            //     columns: [{ header: 'Total Year Energy (KWh)', dataKey: 'total_year_energy' },
            //     { header: 'Specific Yeild (KWh/KWp)', dataKey: 'specific_yeild' },]
            //   })
            // }

            // header first
            if (responseData.header) {
              var headerArr1 = [];
              headerArr1 = Object.keys(responseData.header).map(function (key) {
                return [String(key), responseData.header[key]];
              });

              var dynamicColArr1 = [];
              for (let i = 0; i < headerArr1.length; i++) {
                var key = headerArr1[i][1];
                dynamicColArr1.push({ header: key, dataKey: "value" + i })
              }
              doc.autoTable({
                columns: dynamicColArr1,

              })
            }

            if (responseData.headerSec) {
              var headerArr = [];
              headerArr = Object.keys(responseData.headerSec).map(function (key) {
                return [String(key), responseData.headerSec[key]];
              });

              var dynamicColArr = [];
              for (let i = 0; i < headerArr.length; i++) {
                var key = headerArr[i][1];
                dynamicColArr.push({ header: key, dataKey: "value" + i })
              }
              doc.autoTable({
                body: responseData.generationArr,
                columns: dynamicColArr,

              })
            }

            doc.save(responseData.title + ".pdf");
            this.toastr.success(data.message);
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  downloadReportYeasrZEPlant() {
    var UserIdObj = {
      year: this.pipe.transform(this.reportDownloadForm.value.year, 'yyyy'),
      user_id: this.loginName
    }
    this.dashbord.downloadZEYearPdfZEPlant(UserIdObj)
      .subscribe(
        async data => {
          if (data.status) {
            var responseData = data.resultObject;
            var b64image = JSON.stringify(responseData.epc_b64image);
            // remove quated string
            var base64Img = b64image.replace(/"/g, '');
            var doc = new jspdf('l', 'pt', 'a4'); //landscape page
            // doc.setFontSize(22);
            // doc.text("Month", 14, 20);
            doc.autoTableSetDefaults({
              didDrawPage: function (data) {
                doc.addImage(base64Img, 'png', data.settings.margin.left, 10, 40, 25);
                doc.text(responseData.company_name, data.settings.margin.left + 43, 22);
                doc.text("Plant generation Yearly Report", data.settings.margin.left + 545, 22);
                doc.setDrawColor(31, 78, 121);
                doc.line(0, 45, 900, 45);
              },
              margin: {
                top: 60,
                bottom: 50
              },
            })

            if (responseData.customer) {
              var demo = []
              demo.push(responseData.customer)
              doc.autoTable({
                body: demo,
                columns: [{ header: 'Customer name', dataKey: 'customer_name' }, { header: 'Plant capacity (KW)', dataKey: 'plant_capacity' },
                { header: 'Address', dataKey: 'address' }, { header: 'Year', dataKey: 'date' }]
              })
            }
            // if (responseData.energy_generation) {
            //   var demo1 = []
            //   demo1.push(responseData.energy_generation)
            //   doc.autoTable({
            //     body: demo1,
            //     columns: [{ header: 'Total Year Energy (KWh)', dataKey: 'total_year_energy' },
            //     { header: 'Specific Yeild (KWh/KWp)', dataKey: 'specific_yeild' },]
            //   })
            // }

            // header first
            if (responseData.header) {
              var headerArr1 = [];
              headerArr1 = Object.keys(responseData.header).map(function (key) {
                return [String(key), responseData.header[key]];
              });

              var dynamicColArr1 = [];
              for (let i = 0; i < headerArr1.length; i++) {
                var key = headerArr1[i][1];
                dynamicColArr1.push({ header: key, dataKey: "value" + i })
              }
              doc.autoTable({
                body: responseData.generationArr,
                columns: dynamicColArr1,

              })
            }

            // if (responseData.headerSec) {
            //   var headerArr = [];
            //   headerArr = Object.keys(responseData.headerSec).map(function (key) {
            //     return [String(key), responseData.headerSec[key]];
            //   });

            //   var dynamicColArr = [];
            //   for (let i = 0; i < headerArr.length; i++) {
            //     var key = headerArr[i][1];
            //     dynamicColArr.push({ header: key,  dataKey: "value" + i })
            //   }
            //   doc.autoTable({
            //     body: responseData.generationArr,
            //     columns: dynamicColArr,

            //   })
            // }

            doc.save(responseData.title + ".pdf");
            this.toastr.success(data.message);
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  downloadReportYeasrDgGrid() {
    var UserIdObj = {
      year: this.pipe.transform(this.reportDownloadForm.value.year, 'yyyy'),
      user_id: this.loginName
    }
    this.dashbord.downloadZEYearPdfDGGrid(UserIdObj)
      .subscribe(
        async data => {
          if (data.status) {
            var responseData = data.resultObject;
            var b64image = JSON.stringify(responseData.epc_b64image);
            // remove quated string
            var base64Img = b64image.replace(/"/g, '');
            var doc = new jspdf('l', 'pt', 'a4'); //landscape page
            // doc.setFontSize(22);
            // doc.text("Month", 14, 20);
            doc.autoTableSetDefaults({
              didDrawPage: function (data) {
                doc.addImage(base64Img, 'png', data.settings.margin.left, 10, 40, 25);
                doc.text(responseData.company_name, data.settings.margin.left + 43, 22);
                doc.text("Grid generation Yearly Report", data.settings.margin.left + 545, 22);
                doc.setDrawColor(31, 78, 121);
                doc.line(0, 45, 900, 45);
              },
              margin: {
                top: 60,
                bottom: 50
              },
            })

            if (responseData.customer) {
              var demo = []
              demo.push(responseData.customer)
              doc.autoTable({
                body: demo,
                columns: [{ header: 'Customer name', dataKey: 'customer_name' }, { header: 'Plant capacity (KW)', dataKey: 'plant_capacity' },
                { header: 'Address', dataKey: 'address' }, { header: 'Year', dataKey: 'year' }]
              })
            }
            // if (responseData.energy_generation) {
            //   var demo1 = []
            //   demo1.push(responseData.energy_generation)
            //   doc.autoTable({
            //     body: demo1,
            //     columns: [{ header: 'Total Year Energy (KWh)', dataKey: 'total_year_energy' },
            //     { header: 'Specific Yeild (KWh/KWp)', dataKey: 'specific_yeild' },]
            //   })
            // }

            // header first
            if (responseData.header) {
              var headerArr1 = [];
              headerArr1 = Object.keys(responseData.header).map(function (key) {
                return [String(key), responseData.header[key]];
              });

              var dynamicColArr1 = [];
              for (let i = 0; i < headerArr1.length; i++) {
                var key = headerArr1[i][1];
                dynamicColArr1.push({ header: key, dataKey: "value" + i })
              }
              doc.autoTable({
                columns: dynamicColArr1,

              })
            }

            if (responseData.headerSec) {
              var headerArr = [];
              headerArr = Object.keys(responseData.headerSec).map(function (key) {
                return [String(key), responseData.headerSec[key]];
              });

              var dynamicColArr = [];
              for (let i = 0; i < headerArr.length; i++) {
                var key = headerArr[i][1];
                dynamicColArr.push({ header: key, dataKey: "value" + i })
              }
              doc.autoTable({
                body: responseData.generationArr,
                columns: dynamicColArr,

              })
            }

            doc.save(responseData.title + ".pdf");
            this.toastr.success(data.message);
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  downloadReportYeasrDgLoad() {
    var UserIdObj = {
      year: this.pipe.transform(this.reportDownloadForm.value.year, 'yyyy'),
      user_id: this.loginName
    }
    this.dashbord.downloadZEYearPdfDGLoad(UserIdObj)
      .subscribe(
        async data => {
          if (data.status) {
            var responseData = data.resultObject;
            var b64image = JSON.stringify(responseData.epc_b64image);
            // remove quated string
            var base64Img = b64image.replace(/"/g, '');
            var doc = new jspdf('l', 'pt', 'a4'); //landscape page
            // doc.setFontSize(22);
            // doc.text("Month", 14, 20);
            doc.autoTableSetDefaults({
              didDrawPage: function (data) {
                doc.addImage(base64Img, 'png', data.settings.margin.left, 10, 40, 25);
                doc.text(responseData.company_name, data.settings.margin.left + 43, 22);
                doc.text("Load generation Yearly Report", data.settings.margin.left + 545, 22);
                doc.setDrawColor(31, 78, 121);
                doc.line(0, 45, 900, 45);
              },
              margin: {
                top: 60,
                bottom: 50
              },
            })

            if (responseData.customer) {
              var demo = []
              demo.push(responseData.customer)
              doc.autoTable({
                body: demo,
                columns: [{ header: 'Customer name', dataKey: 'customer_name' }, { header: 'Plant capacity (KW)', dataKey: 'plant_capacity' },
                { header: 'Address', dataKey: 'address' }, { header: 'Year', dataKey: 'year' }]
              })
            }
            // if (responseData.energy_generation) {
            //   var demo1 = []
            //   demo1.push(responseData.energy_generation)
            //   doc.autoTable({
            //     body: demo1,
            //     columns: [{ header: 'Total Year Energy (KWh)', dataKey: 'total_year_energy' },
            //     { header: 'Specific Yeild (KWh/KWp)', dataKey: 'specific_yeild' },]
            //   })
            // }

            // header first
            if (responseData.header) {
              var headerArr1 = [];
              headerArr1 = Object.keys(responseData.header).map(function (key) {
                return [String(key), responseData.header[key]];
              });

              var dynamicColArr1 = [];
              for (let i = 0; i < headerArr1.length; i++) {
                var key = headerArr1[i][1];
                dynamicColArr1.push({ header: key, dataKey: "value" + i })
              }
              doc.autoTable({
                columns: dynamicColArr1,

              })
            }

            if (responseData.headerSec) {
              var headerArr = [];
              headerArr = Object.keys(responseData.headerSec).map(function (key) {
                return [String(key), responseData.headerSec[key]];
              });

              var dynamicColArr = [];
              for (let i = 0; i < headerArr.length; i++) {
                var key = headerArr[i][1];
                dynamicColArr.push({ header: key, dataKey: "value" + i })
              }
              doc.autoTable({
                body: responseData.generationArr,
                columns: dynamicColArr,

              })
            }

            doc.save(responseData.title + ".pdf");
            this.toastr.success(data.message);
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  downloadReportYeasrDgPlant() {
    var UserIdObj = {
      year: this.pipe.transform(this.reportDownloadForm.value.year, 'yyyy'),
      user_id: this.loginName
    }
    this.dashbord.downloadZEYearPdfDGPlant(UserIdObj)
      .subscribe(
        async data => {
          if (data.status) {
            var responseData = data.resultObject;
            var b64image = JSON.stringify(responseData.epc_b64image);
            // remove quated string
            var base64Img = b64image.replace(/"/g, '');
            var doc = new jspdf('l', 'pt', 'a4'); //landscape page
            // doc.setFontSize(22);
            // doc.text("Month", 14, 20);
            doc.autoTableSetDefaults({
              didDrawPage: function (data) {
                doc.addImage(base64Img, 'png', data.settings.margin.left, 10, 40, 25);
                doc.text(responseData.company_name, data.settings.margin.left + 43, 22);
                doc.text("Plant generation Yearly Report", data.settings.margin.left + 545, 22);
                doc.setDrawColor(31, 78, 121);
                doc.line(0, 45, 900, 45);
              },
              margin: {
                top: 60,
                bottom: 50
              },
            })

            if (responseData.customer) {
              var demo = []
              demo.push(responseData.customer)
              doc.autoTable({
                body: demo,
                columns: [{ header: 'Customer name', dataKey: 'customer_name' }, { header: 'Plant capacity (KW)', dataKey: 'plant_capacity' },
                { header: 'Address', dataKey: 'address' }, { header: 'Year', dataKey: 'year' }]
              })
            }
            // if (responseData.energy_generation) {
            //   var demo1 = []
            //   demo1.push(responseData.energy_generation)
            //   doc.autoTable({
            //     body: demo1,
            //     columns: [{ header: 'Total Year Energy (KWh)', dataKey: 'total_year_energy' },
            //     { header: 'Specific Yeild (KWh/KWp)', dataKey: 'specific_yeild' },]
            //   })
            // }

            // header first
            if (responseData.header) {
              var headerArr1 = [];
              headerArr1 = Object.keys(responseData.header).map(function (key) {
                return [String(key), responseData.header[key]];
              });

              var dynamicColArr1 = [];
              for (let i = 0; i < headerArr1.length; i++) {
                var key = headerArr1[i][1];
                dynamicColArr1.push({ header: key, dataKey: "value" + i })
              }
              doc.autoTable({
                columns: dynamicColArr1,

              })
            }

            // if (responseData.headerSec) {
            //   var headerArr = [];
            //   headerArr = Object.keys(responseData.headerSec).map(function (key) {
            //     return [String(key), responseData.headerSec[key]];
            //   });

            //   var dynamicColArr = [];
            //   for (let i = 0; i < headerArr.length; i++) {
            //     var key = headerArr[i][1];
            //     dynamicColArr.push({ header: key,  dataKey: "value" + i })
            //   }
            //   doc.autoTable({
            //     body: responseData.generationArr,
            //     columns: dynamicColArr,

            //   })
            // }

            doc.save(responseData.title + ".pdf");
            this.toastr.success(data.message);
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  downloadReportYeasrDg() {
    var UserIdObj = {
      year: this.pipe.transform(this.reportDownloadForm.value.year, 'yyyy'),
      user_id: this.loginName
    }
    this.dashbord.downloadZEYearPdfDg(UserIdObj)
      .subscribe(
        async data => {
          if (data.status) {
            var responseData = data.resultObject;
            var b64image = JSON.stringify(responseData.epc_b64image);
            // remove quated string
            var base64Img = b64image.replace(/"/g, '');
            var doc = new jspdf('l', 'pt', 'a4'); //landscape page
            // doc.setFontSize(22);
            // doc.text("Month", 14, 20);
            doc.autoTableSetDefaults({
              didDrawPage: function (data) {
                doc.addImage(base64Img, 'png', data.settings.margin.left, 10, 40, 25);
                doc.text(responseData.company_name, data.settings.margin.left + 43, 22);
                doc.text("DG generation Yearly Report", data.settings.margin.left + 545, 22);
                doc.setDrawColor(31, 78, 121);
                doc.line(0, 45, 900, 45);
              },
              margin: {
                top: 60,
                bottom: 50
              },
            })

            if (responseData.customer) {
              var demo = []
              demo.push(responseData.customer)
              doc.autoTable({
                body: demo,
                columns: [{ header: 'Customer name', dataKey: 'customer_name' }, { header: 'Plant capacity (KW)', dataKey: 'plant_capacity' },
                { header: 'Address', dataKey: 'address' }, { header: 'Year', dataKey: 'year' }]
              })
            }
            // if (responseData.energy_generation) {
            //   var demo1 = []
            //   demo1.push(responseData.energy_generation)
            //   doc.autoTable({
            //     body: demo1,
            //     columns: [{ header: 'Total Year Energy (KWh)', dataKey: 'total_year_energy' },
            //     { header: 'Specific Yeild (KWh/KWp)', dataKey: 'specific_yeild' },]
            //   })
            // }

            // header first
            if (responseData.header) {
              var headerArr1 = [];
              headerArr1 = Object.keys(responseData.header).map(function (key) {
                return [String(key), responseData.header[key]];
              });

              var dynamicColArr1 = [];
              for (let i = 0; i < headerArr1.length; i++) {
                var key = headerArr1[i][1];
                dynamicColArr1.push({ header: key, dataKey: "value" + i })
              }
              doc.autoTable({
                columns: dynamicColArr1,

              })
            }

            if (responseData.headerSec) {
              var headerArr = [];
              headerArr = Object.keys(responseData.headerSec).map(function (key) {
                return [String(key), responseData.headerSec[key]];
              });

              var dynamicColArr = [];
              for (let i = 0; i < headerArr.length; i++) {
                var key = headerArr[i][1];
                dynamicColArr.push({ header: key, dataKey: "value" + i })
              }
              doc.autoTable({
                body: responseData.generationArr,
                columns: dynamicColArr,

              })
            }

            doc.save(responseData.title + ".pdf");
            this.toastr.success(data.message);
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  ngOnDestroy() {
    this.ResponseVerifiedGetInverterList.next();
    this.ResponseVerifiedGetInverterList.complete();

    this.ResponseVerifiedGetParamList.next();
    this.ResponseVerifiedGetInverterList.complete();

    this.ResponseVerifiedReportGraph.next();
    this.ResponseVerifiedReportGraph.complete();

  }
}
